import ERRORS from '~/constants/errors';

import { Rule } from './types';

export const propertyValueRule: Rule = ({ businessDetails, isPropertyOwner, industries }) => {
  if (
    !isPropertyOwner ||
    !businessDetails ||
    !businessDetails.industry ||
    !industries ||
    !businessDetails.propertyValue
  )
    return undefined;
  const propertyOwnerIndustryCode = businessDetails.propertyOwnerOccupation?.industryCode;
  if (!propertyOwnerIndustryCode) return undefined;
  const propertyIndustry = industries.find(
    (industry) => industry.industryCode === propertyOwnerIndustryCode
  );
  if (!propertyIndustry || !propertyIndustry.limits?.propertyValue) return undefined;
  if (businessDetails.propertyValue > propertyIndustry.limits?.propertyValue) {
    return ERRORS.propertyValue;
  }
  return undefined;
};
